export const URL_API = 'https://api.themoviedb.org/3';
export const API = 'eb12db4079593dc602b006a3e1706d8c';